import { PlayerType } from "../registration/model";

export interface Player {
    id?: string;
    name?: string;
    surname?: string;
    birthDate?: string;
    gender?: string;
    joined?: Date;
    level?: string;
    phoneNumber?: string;
    email?: string;
    referral?: string;
    rewardPoints?: number;
    preferredClubs?: string[];
    preferredTime?: string;
    playerType?: PlayerType;
    preferredClubsDescription?: string;
    isVerified?: boolean;
    disableMatchOfferNotifications?: boolean;
    parentName?: string;
    parentSurname?: string;
    isChildAccount?: boolean;

    heightCm?: number;
    backhand?: BackhandType;
    style?: PlayStyle;
    homeClub?: string;
}

export enum BackhandType {
    OneHanded,
    TwoHanded
}

export enum PlayStyle {
    Offensive,
    Defensive,
    Neutral
}